import { Difficulty } from "../../../Difficulty";
import { LooopAudioFiles } from "../../../Looop";

export const isThisCompOnOptions: {
  [difficulty in Difficulty]: [keyof LooopAudioFiles, keyof LooopAudioFiles][];
} = {
  easy: [
    ["default", "default"],
    ["default", "comp_opto7"],
    ["default", "comp_opto10"],
    ["comp_opto1", "comp_opto10"],
  ],
  medium: [
    ["default", "default"],
    ["default", "comp_opto4"],
    ["comp_opto1", "comp_opto7"],
    ["comp_opto1", "comp_opto10"],
    ["comp_opto2", "comp_opto7"],
    ["comp_opto2", "comp_opto10"],
  ],
  hard: [
    ["default", "default"],
    ["default", "comp_opto1"],
    ["default", "comp_opto2"],
    ["comp_opto1", "comp_opto2"],
    ["comp_opto2", "comp_opto4"],
    ["comp_opto4", "comp_opto7"],
  ],
};
